var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Search Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-2", attrs: { dense: "" } },
                [
                  !_vm.model.useFilters
                    ? [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6", md: "6" } },
                          [
                            _c("v-checkbox", {
                              staticClass: "mx-1 mt-0",
                              attrs: {
                                label: "Major search",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.model.major,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "major", $$v)
                                },
                                expression: "model.major",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6", md: "6" } },
                          [
                            _c("v-checkbox", {
                              staticClass: "mx-1 mt-0",
                              attrs: {
                                label: "Minor search",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.model.minor,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "minor", $$v)
                                },
                                expression: "model.minor",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6", md: "6" } },
                          [
                            _c("v-checkbox", {
                              staticClass: "mx-1 mt-0",
                              attrs: {
                                label: "Skip Locked",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.model.skipLocked,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "skipLocked", $$v)
                                },
                                expression: "model.skipLocked",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6", md: "6" } },
                          [
                            _c("v-checkbox", {
                              staticClass: "mx-1 mt-0",
                              attrs: {
                                label: "Skip Unlocked",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.model.skipUnlocked,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "skipUnlocked", $$v)
                                },
                                expression: "model.skipUnlocked",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "12" } },
                    [
                      _c("r-item-table", {
                        attrs: { items: _vm.model.sources, title: "Sources" },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(_vm.model, "sources", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mx-1 mt-3",
                        attrs: {
                          label: "Use Advanced Filters",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.useFilters,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "useFilters", $$v)
                          },
                          expression: "model.useFilters",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.model.useFilters
                    ? [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("v-divider", { staticClass: "my-3" }),
                            _c("h4", { staticClass: "mb-3" }, [
                              _vm._v("Filter Tags"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6", md: "6" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "pa-3", attrs: { outlined: "" } },
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "pa-0 mb-2" },
                                  [_vm._v("Positive Filters")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-wrap mb-2" },
                                  _vm._l(
                                    _vm.model.positiveFilters,
                                    function (filter, index) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: "pos-" + index,
                                          staticClass: "ma-1",
                                          attrs: { close: "", small: "" },
                                          on: {
                                            "click:close": function ($event) {
                                              return _vm.removePositiveFilter(
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getFilterLabel(
                                                  filter,
                                                  "positive"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-wrap" },
                                  _vm._l(
                                    _vm.positiveFilterOptions,
                                    function (option) {
                                      return _c(
                                        "v-btn",
                                        {
                                          key: "pos-btn-" + option.value,
                                          staticClass: "ma-1",
                                          attrs: {
                                            disabled:
                                              _vm.model.positiveFilters.includes(
                                                option.value
                                              ),
                                            small: "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addPositiveFilter(
                                                option.value
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(option.label) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6", md: "6" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "pa-3", attrs: { outlined: "" } },
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "pa-0 mb-2" },
                                  [_vm._v("Negative Filters")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-wrap mb-2" },
                                  _vm._l(
                                    _vm.model.negativeFilters,
                                    function (filter, index) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: "neg-" + index,
                                          staticClass: "ma-1",
                                          attrs: {
                                            close: "",
                                            small: "",
                                            color: "error",
                                          },
                                          on: {
                                            "click:close": function ($event) {
                                              return _vm.removeNegativeFilter(
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getFilterLabel(
                                                  filter,
                                                  "negative"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-wrap" },
                                  _vm._l(
                                    _vm.negativeFilterOptions,
                                    function (option) {
                                      return _c(
                                        "v-btn",
                                        {
                                          key: "neg-btn-" + option.value,
                                          staticClass: "ma-1",
                                          attrs: {
                                            disabled:
                                              _vm.model.negativeFilters.includes(
                                                option.value
                                              ),
                                            small: "",
                                            outlined: "",
                                            color: "error",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addNegativeFilter(
                                                option.value
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(option.label) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }